import { Messages } from '@openreplay/tracker';
export default function () {
    return (app) => {
        if (app === null) {
            return (name) => (fn, thisArg) => thisArg === undefined ? fn : fn.bind(thisArg);
        }
        return (name) => (fn, thisArg) => (...args) => {
            const startTime = performance.now();
            const result = thisArg === undefined ? fn.apply(this, args) : fn.apply(thisArg, args);
            const duration = performance.now() - startTime;
            app.send(Messages.Profiler(name, duration, args.map(String).join(', '), String(result)));
            return result;
        };
    };
}
